<template lang='pug'>
  r-table(
    no-data-text='Sin pagos de proveedores.'
    no-remove
    no-search
    ref='table'
    v-bind='tableProps'
    @detail='submitDetail'
  )
</template>

<script>
  //
  import { RTable } from '@/components/reusable_components/next'
  //
  import ProviderPaymentService from '@/services/api/purchase/PchProviderPayment'
  import ProviderPaymentFilters from '@/views/Purchase/PchProviderPayment/PchProviderPaymentFilters'
  import ProviderPaymentHeaders from '@/views/Purchase/PchProviderPayment/PchProviderPaymentHeaders'
  //
  export default {
    components: {
      RTable,
    },
    computed: {

      /**
       * { function_description }
       *
       * @return     {Object}  { description_of_the_return_value }
       */
      tableProps () {
        return {
          filters: ProviderPaymentFilters,
          headers: ProviderPaymentHeaders,
          service: new ProviderPaymentService().toList(),
        }
      },
    },
    methods: {

      /**
       * { function_description }
       */
      submitCreate() {
        this.$router.push({ name: 'provider-payment-create' })
      },

      /**
       * { function_description }
       *
       * @param      {<type>}  event   The event
       */
      submitDetail(event) {
        this.$router.push({ name: 'provider-payment-update', params: { id: event.item.id } })
      },
    },
    beforeMount () {
      this.setTitle('Pagos de proveedores')
    },
    mounted() {
      this.setItems([
        {
          text: 'crear pago de proveedor',
          icon: 'add_circle',
          action: this.submitCreate,
        },             
      ])
    }
  }
</script>